import script from "./Step1GroupDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1GroupDetails.vue?vue&type=script&setup=true&lang=js"

import "./Step1GroupDetails.vue?vue&type=style&index=0&id=0440a214&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0440a214"]])

export default __exports__